import { createStyles, makeStyles } from '@material-ui/core'
import React, { useState } from 'react'
import {
  sanitizeFetchType,
  useMutation,
  useNotify,
  useShowContext,
} from 'react-admin'
import { Authority } from '../../../../core/auth/Authority'
import { ResourceName } from '../../../../core/ResourceName'
import { ConfirmDialog } from '../../../common/ConfirmDialog'
import Button from '../../../common/customized-mui-components/Button'
import { useHasAuthority } from '../../../hooks/useHasAuthority'
import { DoorDto } from '../../../../core/dto/device/doors/door.dto'

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      margin: '2px',
    },
  }),
)

export const DoorForceReportStateButton = () => {
  const { record: door, loading } = useShowContext<DoorDto>()
  const classes = useStyles()
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false)
  const hasAuthority = useHasAuthority()
  const [mutate, { loading: mutationLoading }] = useMutation()
  const notify = useNotify()

  const handleMutate = async () => {
    setConfirmDialogOpen(false)
    await mutate(
      {
        type: sanitizeFetchType('forceReportState'),
        resource: ResourceName.DOORS,
        payload: {
          id: door?.id,
        },
      },
      {
        returnPromise: true,
        onFailure: (err) => notify(err?.message, 'error'),
      },
    )
  }

  const handleConfirm = () => {
    setConfirmDialogOpen(true)
  }

  return (
    <>
      <ConfirmDialog
        open={confirmDialogOpen}
        confirm={handleMutate}
        source="forceReportState"
        cancel={() => setConfirmDialogOpen(false)}
        action="set"
        resource={ResourceName.DOORS}
      />
      <Button
        variant="contained"
        onClick={handleConfirm}
        color="primary"
        className={classes.button}
        label="resources.doors.actions.forceReportState"
        useSmallVersionBreakpoint={false}
        disabled={
          !hasAuthority(Authority.DOORS_FORCE_REPORT_STATE) ||
          loading ||
          mutationLoading
        }
      />
    </>
  )
}
